import { Capacitor } from '@capacitor/core'
import { SESSION_USER_CLAIMS, getUserPref, spLogTags } from '@eventr/common'
import { StateCreator } from 'zustand'
import { resetAllStores } from '../feat/appState/resetState'
import { PushNotifications } from '../feat/push/plugin'
import { Utils } from '../utils'
import { BoundStore } from './bound.store'
import { useLiveLocationStore } from './liveLocationState/liveLocation.store'

interface AppEventState {
    refreshKey: number
}
interface AppEventActions {
    onLogin: () => Promise<void>
    logout: () => Promise<void>
    removePushToken: () => void
    onReturn: () => void
    onOpen: () => void
}

export interface AppEventSlice extends AppEventState, AppEventActions {}

export const createAppEventSlice: StateCreator<
    BoundStore,
    [['zustand/devtools', never]],
    [],
    AppEventSlice
> = (set, get) => ({
    refreshKey: 0,
    onLogin: async () => {
        await get().getProfile()
        // resolve org based on userPrefs
        const defaultOrgPref = getUserPref('account', 'defaultOrg')
        let orgToUse = null
        if (defaultOrgPref) {
            orgToUse = get().profile?.organisations.find(
                (org) => org.name === defaultOrgPref
            )
        } else {
            orgToUse = get().profile?.organisations[0]
        }
        if (orgToUse) {
            console.log('orgToUse', orgToUse)

            await get().setSelectedOrg(orgToUse)
        }
        set({ loginCompleted: true }, false, 'onLogin')
    },

    logout: async () => {
        spLogTags('Full logout called', ['DEBUG'])
        // deleting userOrgPreferences should be after this function
        get().clearCalendars()
        localStorage.removeItem(SESSION_USER_CLAIMS)
        localStorage.removeItem('userOrgPreferences')
        localStorage.removeItem('userPreferences')
        indexedDB.deleteDatabase('chatStore')
        useLiveLocationStore.setState({ sharingStaleTimestamp: undefined })
        Utils.logoutClient()
        get().removePushToken()
        resetAllStores()
    },
    removePushToken: () => {
        if (Capacitor.isNativePlatform()) {
            PushNotifications.unregister()
        }
    },

    onReturn: async () => {
        if (get().IDtoken) {
            await get().getProfile()
            // resolve org based on userPrefs
            const defaultOrgPref = getUserPref('account', 'defaultOrg')
            if (defaultOrgPref && defaultOrgPref !== get().selectedOrg?.name) {
                const orgToUse = get().profile?.organisations.find(
                    (org) => org.name === defaultOrgPref
                )
                if (!orgToUse) {
                    return
                }
                await get().setSelectedOrg(orgToUse)
                return
            }
            set({ refreshKey: Math.random() })
            // make all org request
            const promises = []
            promises.push(
                get().fetchUsers(),
                get().fetchOrgConfig(),
                get().fetchFields(),
                get().fetchSections(),
                get().setProfileShareSections(),
                get().forceItineraryMapUpdate(),
                get().loadRequests(),
                get().getApiUpdates(),
                useLiveLocationStore.getState().init()
            )
            await Promise.all(promises)
        }
    },
    onOpen: async () => {
        get().initVersionConfig()
        get().onFirstOpened()
    },
})
